import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class RackZoneMappingDtO {

    @ApiProperty()
    @IsOptional()
    rackZoneMappingId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    isActive: boolean;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    createdUser: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    updatedUser: string;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    rackId: number;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    zoneId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    endCustomerId: number;


}

